import React, { useState, memo, useEffect } from 'react';
import { useQuery } from 'react-query';
import * as API from 'api';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiPaper from '@material-ui/core/Paper';
import MuiTablePagination from '@material-ui/core/TablePagination';

import ListGroupTableRow from './list-groups-table-row';

const Groups = API.Groups();

function TableGroups({ selectedSearchTerm, selectedGroupId }) {
  const [selectedGroup, setSelectedGroup] = useState(false);
  const [params, setParams] = useState({ page: 0, rowsPerPage: 25 });

  //I normally hate useEffect, but this is the best way to reset page on search changes.
  useEffect(() => {
    setParams({ ...params, page: 0 });
  }, [selectedSearchTerm]);

  const { data, isLoading, refetch } = useQuery(
    ['groups', selectedSearchTerm, params.page, params.rowsPerPage, selectedGroupId],
    () => {
      const newParams = { ...params };
      if (selectedSearchTerm) newParams.search = selectedSearchTerm;
      if (selectedGroupId && !selectedSearchTerm) newParams.selectedGroupId = selectedGroupId;
      return Groups.getAllWithSubscription(newParams);
    },
    {
      select: data => ({ total: data.total, groups: data.results }),
    }
  );

  function handleChangePage(_, page) {
    setParams({ ...params, page: page });
  }

  function handleChangeRowsPerPage({ target: { value } }) {
    setParams({ ...params, page: 0, rowsPerPage: value });
  }

  if (isLoading) return <MuiCircularProgress />;

  return (
    <MuiTableContainer component={MuiPaper}>
      <MuiTable aria-label="collapsible table">
        <MuiTableHead>
          <MuiTableRow>
            <MuiTableCell>id</MuiTableCell>
            <MuiTableCell>Name</MuiTableCell>
            <MuiTableCell>Email</MuiTableCell>
            <MuiTableCell>Subscription Tier</MuiTableCell>
            <MuiTableCell>NFT Status</MuiTableCell>
            <MuiTableCell>Actions</MuiTableCell>
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          <MuiTableRow>
            <MuiTablePagination
              rowsPerPageOptions={[25, 50, 100]}
              rowsPerPage={params.rowsPerPage}
              count={data?.total || 0}
              page={params.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </MuiTableRow>
          {data?.groups?.map(group => (
            <ListGroupTableRow
              key={group.user_group_id}
              group={group}
              setSelectedGroup={setSelectedGroup}
              isExpanded={group.user_group_id === selectedGroup.id}
              refetchGroups={refetch}
            />
          ))}
          <MuiTableRow>
            <MuiTablePagination
              rowsPerPageOptions={[25, 50, 100]}
              rowsPerPage={params.rowsPerPage}
              count={data?.total || 0}
              page={params.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </MuiTableRow>
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
}

//memo here is because we only want it to re-render when the chosen props change, not whenever a user is typing into the parent search.
export default memo(TableGroups);
